export function FourOThree() {
  return (
    <>
      <h2>ERROR 403</h2>
      <h1>Access Denied</h1>
    </>
  )
}
